import React, { useContext, useState } from 'react';
import { CartBasketContext } from '../contexts';
import ImageComponent from '../image';
import TextBox from '../text_box';
import { GenericIcon } from '../generic/icon';

interface ProdRef {
  [key: string]: string[];
}

export const Product: React.FC<{
  product: string;
  number_in_cart: number;
}> = props => {
  const { cartBasket, setCartBasket } = useContext(CartBasketContext);
  const product_refs: ProdRef = {
    coffee_machine: [
      'Coffee Machine',
      require('../../images/products/coffee_machine.png'),
      'coffee vending machine',
    ],
    tubz_machine: [
      'Tubz Vending Machine',
      require('../../images/products/tubz_tower.jpeg'),
      'tubz tower vending machine',
    ],
    vending_machine: [
      'Vending Machine',
      require('../../images/products/vending_machine.webp'),
      'vending machine',
    ],
  };
  const [quantity, setQuantity] = useState(props.number_in_cart);

  const handleAddClick = (product_clicked: string) => {
    switch (product_clicked) {
      case 'coffee_machine':
        setCartBasket({
          ...cartBasket,
          coffee_machine: cartBasket.coffee_machine + 1,
        });
        break;
      case 'tubz_machine':
        setCartBasket({
          ...cartBasket,
          tubz_machine: cartBasket.tubz_machine + 1,
        });
        break;
      case 'vending_machine':
        setCartBasket({
          ...cartBasket,
          vending_machine: cartBasket.vending_machine + 1,
        });
        break;
      default:
        break;
    }
    setQuantity(quantity + 1);
  };
  const handleRemoveClick = (product_clicked: string) => {
    switch (product_clicked) {
      case 'coffee_machine':
        setCartBasket({
          ...cartBasket,
          coffee_machine: cartBasket.coffee_machine - 1,
        });
        break;
      case 'tubz_machine':
        setCartBasket({
          ...cartBasket,
          tubz_machine: cartBasket.tubz_machine - 1,
        });
        break;
      case 'vending_machine':
        setCartBasket({
          ...cartBasket,
          vending_machine: cartBasket.vending_machine - 1,
        });
        break;
      default:
        break;
    }
    setQuantity(quantity - 1);
  };

  return (
    <div className="product_cart row">
      <TextBox type='title' text={product_refs[props.product][0]} />
      <ImageComponent
        src={product_refs[props.product][1]}
        alt={product_refs[props.product][2]}
      />
      <div className="product_cart__incrementors">
        <GenericIcon
          icon='remove'
          classes='mr-20 interactable'
          onClick={() => handleRemoveClick(props.product)}
        />
        <TextBox type="text" text={quantity.toString()} />
        <GenericIcon
          icon='add'
          classes='ml-20 interactable'
          onClick={() => handleAddClick(props.product)}
        />
      </div>
    </div>
  );
};
